import { f as fragmentDefaultEntryName } from "../common/consts.js";
import { u as useFragmentNetwork } from "./fragmentNetwork.js";
function useFederationNetwork({
  i18next,
  versions,
  processException
}) {
  const fragmentNetworks = /* @__PURE__ */ new Map();
  return {
    preload,
    getManifest,
    loadManifest,
    getFragmentNetwork
  };
  function getFragmentNetwork(fragmentName) {
    if (!fragmentNetworks.has(fragmentName)) {
      const network = useFragmentNetwork({ versions, fragmentName, processException });
      fragmentNetworks.set(fragmentName, network);
    }
    return fragmentNetworks.get(fragmentName);
  }
  async function loadManifest(options) {
    return getFragmentNetwork(options.fragmentName).loadManifest();
  }
  function getManifest(options) {
    return getFragmentNetwork(options.fragmentName).getManifest();
  }
  async function preload(options) {
    const language = options.language ?? (i18next == null ? void 0 : i18next.language);
    const fragmentNetwork = getFragmentNetwork(options.fragmentName);
    const entryName = options.entryName ?? fragmentDefaultEntryName;
    await fragmentNetwork.preload({ entryName, language });
  }
}
export {
  useFederationNetwork as u
};
//# sourceMappingURL=network.js.map
